import { useEffect, useState } from "react";
import alert from "./Alert.module.css";
import Backdrop from "../Backdrop/Backdrop"
import { AlertEntity } from "./AlertEntity";

import { IoMdCloudDone, IoMdWarning } from "react-icons/io";
import { MdDangerous } from "react-icons/md";

function Alert(props: { showAlert: boolean; setShowAlert: (val: boolean) => void; alertEntity: AlertEntity | null; }): JSX.Element {
  const {
    showAlert,
    setShowAlert,
    alertEntity
  } = props;

  let entity = new AlertEntity({ message: '[ALERT IS NOT SET]' });
  if (alertEntity != null && !alertEntity.isEmpty()) entity = alertEntity;

  const message = entity.message;
  const delay = entity.delay;
  const onClose = entity.onClose;
  const onOk = entity.onOk;
  const withOK = entity.withOk;
  const withCancel = entity.withCancel;
  const withInput = entity.withInput;
  const level = entity.level;

  const [inputValue, setInputValue] = useState("");
  const [alertLevel, setAlertLevel] = useState(2);
  const [countingDown, setCountingDown] = useState(delay ?? 10);

  useEffect(() => {
    setAlertLevel(level ?? 2);
  }, [level]);

  useEffect(() => {
    if (withOK !== true) {
      setCountingDown(delay ?? 10);
      const timeoutId = setTimeout(() => {
        if (withCancel !== true) {
          if (onClose != null) onClose();
          return setShowAlert(false);
        }
      }, (delay ?? 10) * 1000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [delay, setShowAlert, withCancel, withOK, onClose]);

  useEffect(() => {
    if (countingDown === 0 && withOK !== true) {
      if (typeof onOk === "function") {
        onOk();
        return setShowAlert(false);
      }
      if (onClose != null) onClose();
      return setShowAlert(false);
    }
  }, [countingDown, setShowAlert, onClose, onOk, withOK]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountingDown((prevCounting) =>
        prevCounting <= 0 ? 0 : prevCounting - 1
      );
    }, 1000);
    return () => clearInterval(interval);
  }, [showAlert]);

  function clickOK() {
    if (typeof onOk === "function") {
      console.log("Executed from Component");
      onOk();
      return setShowAlert(false);
    }
    setCountingDown(0);
    if (onClose != null) onClose();
    return setShowAlert(false);
  }

  function clickCancel() {
    setInputValue("");
    setCountingDown(0);
    if (onClose != null) onClose();
    return setShowAlert(false);
  }

  return (
    <>
      {showAlert && <Backdrop zIndex={0} close={() => { }} />}
      {showAlert && (
        <div className={alert.container}>
          <div
            className={
              alertLevel === 1
                ? alert.symbolDone
                : alertLevel === 2
                  ? alert.symbolWarn
                  : alert.symbolCritical
            }
          >
            {alertLevel === 1 ? (
              <IoMdCloudDone style={{ fontSize: "4vw" }} />
            ) : alertLevel === 2 ? (
              <IoMdWarning style={{ fontSize: "4vw" }} />
            ) : (
              <MdDangerous style={{ fontSize: "4vw" }} />
            )}
          </div>
          <div className={alert.content}>
            <div className={alert.info}>{message}</div>
            {withInput && (
              <div className={alert.input}>
                <input
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  required={true}
                  autoComplete="off"
                />
              </div>
            )}
            <div className={alert.buttons}>
              {(withCancel || !withOK) && (
                <button className="tertiaryButton" onClick={clickCancel}>
                  Close{!withOK ? `(${countingDown})` : null}
                </button>
              )}

              {((withOK === true) &&
                <button className="primaryButton" onClick={clickOK}>
                  OK
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export { Alert };
